import { LockedArt } from '@/components/illustrations';
import { Button, Card, CardContent } from '@/components/cargofl-ui';
import { useSignOut } from '@/lib/session';

/** Shared by both dead-end screens, so signing out works the same way from either. */
export function SignOutButton() {
  const signOut = useSignOut();
  return (
    <Button variant="secondary" onClick={() => void signOut()}>
      Sign out
    </Button>
  );
}

/**
 * The employee record is EXITED.
 *
 * Distinct from unauthenticated: their credentials are valid, so /login would loop.
 * The record itself is kept - it is the history of what they held - which is exactly
 * why the account cannot simply be deleted to solve this.
 */
export function AccountDisabledPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-[480px]">
        <CardContent className="space-y-5 py-10 text-center sm:py-10">
          <LockedArt className="mx-auto h-28 w-auto" />
          <h1 className="text-lg font-semibold">This account is no longer active</h1>
          <p className="text-sm text-muted-foreground">
            Your employee record has been marked as exited, so you cannot sign in. If that is
            wrong — you have rejoined, or it was recorded in error — HR can reinstate it.
          </p>
          <SignOutButton />
        </CardContent>
      </Card>
    </div>
  );
}
